<div class="chat-box" *ngIf="!isNotes && !isMessages"><!-- <== CHAT BOX -->
  <div style="flex:1;"></div>
  <div class="messages">
    <div class="comment-group-holder" [ngClass]="{yours: commentGroup.by === userService.email}" *ngFor="let commentGroup of commentGroups">
      <photo [size]="36" [data]="workersByEmail[commentGroup.by] || {title: commentGroup.by}"></photo>
      <div class="comments-holder">
        <ng-container [ngTemplateOutlet]="nameDate" [ngTemplateOutletContext]="{ at: commentGroup.at, email: commentGroup.by, worker: workersByEmail[commentGroup.by] }"></ng-container>
        <div class="comment" *ngFor="let comment of commentGroup.comments" [innerHTML]="helpers.strWithBreak(comment)"></div>
      </div>
    </div>
  </div>
  <div class="add-comments-row">
    <div #newCommentDiv [contentEditable]="!readOnly" placeholder="Message..." [ngClass]="{readOnly: readOnly}" class="comment-box" (input)="commentInput($event)" (keyup.enter)="clearMessage()" (keydown.enter)="send()"></div>
    <icon class="send" icon="send24" [ngClass]="{valid: !(newMessage | onlyWhitespace)}" (click)="send()"></icon>
  </div>
</div>

<div class="chat-box" *ngIf="!!isMessages"><!-- <== MESSAGES -->
  <div style="flex:1;"></div>
  <div class="messages">
    <div class="comments-holder" *ngIf="!!comments.length">
      <quick-note 
        *ngFor="let note of comments; index as noteIndex; trackBy: trackById" 
        [ngClass]="{ unread: unreadIds.includes(note.id) }"
        [note]="note" 
        [readOnly]="true"
        [user]="workersByEmail[note.createdBy] || {title: note.createdBy}"
      >
        <ng-container [ngTemplateOutlet]="nameDate" [ngTemplateOutletContext]="{ at: note.createdAt['seconds'] * 1000, email: note.createdBy, worker: workersByEmail[note.createdBy], edited: note.edited, notes: true }"></ng-container>
      </quick-note>
    </div>
  </div>
  <div class="add-comments-row" *ngIf="!readOnly">
    <div #newCommentDiv [contentEditable]="!readOnly" placeholder="Message..." [ngClass]="{readOnly: readOnly}" class="comment-box" (input)="commentInput($event)" (keyup.enter)="clearMessage()" (keydown.enter)="send()"></div>
    <icon icon="attach24"></icon>
    <icon class="send" icon="send24" [ngClass]="{valid: !(newMessage | onlyWhitespace)}" (click)="send()"></icon>
  </div>
</div>

<div class="note-box" *ngIf="!!isNotes"><!-- <== QUICK NOTES -->
  <title-icon class="margin-top" [title]="'Quick Notes'" [titleIcon]="'sticky18'"></title-icon>

  <div class="new-note-holder">
    <photo [size]="36" [data]="user"></photo>
    <div class="new-note smooth">
      <div #newCommentDiv [contentEditable]="!readOnly" (focusin)="focusNewNote()" (focusout)="unfocusNewNote()" placeholder="Add a note..." [ngClass]="{readOnly: readOnly}" class="comment-box" (input)="commentInput($event)"></div>
      <div class="new-note-actions smooth" [ngClass]="{ visible: editingNewNote }">
        <div style="flex:1;"></div>
        <button mat-button (click)="cancelNewNote()">CANCEL</button>
        <button mat-button color="primary" class="inner-primary" [disabled]="newMessage | onlyWhitespace" (click)="send()">ADD NOTE</button>
      </div>
    </div>
  </div>
  <div class="placeholder" *ngIf="!comments.length">
    <null-state [background]="'unset'" [inputData]="nullStateData" [hideButton]="true"></null-state>
  </div>
  <div class="comments-holder" *ngIf="!!comments.length">
    <quick-note 
      *ngFor="let note of comments; index as noteIndex; trackBy: trackById" 
      [note]="note" 
      [readOnly]="readOnly || user?.email !== note.createdBy"
      [user]="workersByEmail[note.createdBy] || {title: note.createdBy}"
      (delete)="deleteNote(noteIndex)"
      (save)="saveNote(noteIndex, $event)"
    >
      <ng-container [ngTemplateOutlet]="nameDate" [ngTemplateOutletContext]="{ at: note.createdAt['seconds'] * 1000, email: note.createdBy, worker: workersByEmail[note.createdBy], edited: note.edited, notes: true }"></ng-container>
    </quick-note>
  </div>
</div>


<ng-template #nameDate let-at="at" let-email="email" let-worker="worker" let-edited="edited" let-notes="notes">
  <div class="name-date" [ngClass]="{ notes: notes }"><b>{{ worker ? worker.firstName + ' ' + worker.lastName : email }}</b> {{ at | date: 'E dd MMM, HH:mma' }}<ng-container *ngIf="!!edited"> (edited)</ng-container></div>
</ng-template>